<style lang="stylus">
.creditTrack {
  margin-top: 20px;

  .transDetails {
    p {
      margin-bottom: 0px;
    }
  }

  .credit-text {
    font-size: 26px;
    padding: 0px 8px 8px 28px;
  }

  img {
    width: 50px;
    height: auto;
  }

  .cet {
    font-size: 24px;
  }

  .flex.sm2 {
    max-width: 60px;
  }
}

.creditTrack {
  margin-top: 20px;

  .transDetails {
    p {
      margin-bottom: 0px;
    }
  }

  .credit-text {
    font-size: 26px;
    padding: 8px 8px 8px 28px;
  }

  img {
    width: 75px;
    // height: 45px;
    object-fit: contain;
  }

  @media (max-width: 600px) {
    .flex.sm2 {
      max-width: 80px;
    }
  }

  @media (min-width: 700px) and (max-width: 800px) {
    .credit-text {
      font-size: 26px;
      padding: 0px 8px 8px 2px;
    }
  }

  @media (min-width: 1024px) and (max-width: 1030px) {
    .credit-text {
      font-size: 26px;
      padding: 0px 8px 8px 50px;
    }
  }

  @media (min-width: 960px) and (max-width: 1260px) {
    .receiptSection {
      padding-left: 42px;
    }
  }

  @media (min-width: 1270px) {
    .receiptSection {
      padding-left: 35px;
    }
  }

  @media (min-width: 768px) and (max-width: 805px) {
    .receiptSection {
      padding-left: 10px;
    }
  }

  @media (max-width: 480px) {
    .credit-text {
      font-size: 24px;
      padding: 0px 8px 8px 18px;
    }

    .reviewSelec-button-width {
      width: 33%;
    }

    .receiptSection {
      padding-left: 15px;
    }

    img {
      width: 75px;
      height: auto;
    }
  }
}

.sticky-section {
  top: 10px !important;
  position: sticky !important;
}

.gpa-calc {
  color: rgb(140, 29, 64);
  text-decoration: underline;
  font-weight: 400;
}

.credit-list {
  margin-left: 6px;
}

.about-credit {
  padding-right: 80px;
}

.about-credit {
  @media (min-width: 1025px) {
    margin-left: 30px;
    margin-bottom: 250px;
  }

  @media (min-width: 800px) and (max-width: 850px) {
    margin-left: 28px;
  }

  @media (min-width: 900px) and (max-width: 1024px) {
    margin-left: 52px;
  }
}

.about-credit {
  @media (min-width: 768px) and (max-width: 770px) {
    margin-left: -12px;
  }

  @media (min-width: 2000px) {
    margin-left: 23px;
  }
}

.addToTransClass {
  // padding-right :90px !important
  @media (min-width: 1024px) {
    margin-left: 30px;
    padding-right: 90px !important;
  }

  @media (min-width: 768px) and (max-width: 770px) {
    margin-left: -12px;
  }
}

.eligible-list {
  font-size: 16px;
  margin-left: 5px;
  font-weight: normal;
}

.forCourseSection {
  padding: 8px 0px 8px 28px;

  @media (min-width: 900px) {
    margin-left: 23px;
  }

  @media (max-width: 800px) {
    margin-left: 15px;
  }

  @media (min-width: 2000px) {
    margin-left: 45px;
  }
}

li::marker {
  font-weight: bold;
}

.reviewSelec {
  border-style: solid;
  border-radius: 50px;
  border-color: #fec627;
  padding: 0px 0px 0px 10px;
  background-color: #fec627;
  font-size: 12px;
  font-weight: 600;
  color: black;
  height: 43px;
  align-items: center;
  justify-content: center;
}

.reviewSelec-button-width {
  width: 26%;
  margin: 48px 0 0 0;
  display: flex;
  cursor: pointer;
}

.text-margin {
  @media (min-width: 766px) and (max-width: 770px) {
    margin-left: 25px;
  }
}
</style>

<template>
  <v-container class="container">
    <div>
      <v-row no-gutters class="mt-12">
        <div class="mobile-anchor-border d-flex d-sm-none" />
        <v-col cols="12" md="8" lg="8" xl="8">
          <!-- Course description for what the user is paying for -->
          <v-row row wrap style="margin-bottom: 13px">
            <v-col cols="12" md="11" lg="11" xl="11" style="margin-bottom: 8px">
              <div class="courseLabel left-border">
                <strong>{{ pageTitle }}</strong>
              </div>
            </v-col>
          </v-row>

          <!-- Brief description of steps -->
          <div class="creditTrack">
            <v-row class="justify-space-between" style="align-items: baseline">
              <v-col cols="3" sm="1" md="1" lg="1" xl="1">
                <v-row class="justify-space-between" column fill-height>
                  <v-col cols="12">
                    <img src="../assets/icons/asu_logo.png" />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="10" sm="11" md="11" lg="11" xl="11" class="text-margin">
                <p class="credit-text">
                  <strong>
                    <b> Course: {{ title }}</b>
                  </strong>
                </p>
              </v-col>
            </v-row>
            <v-row
              v-if="buttonLabel === 'Upgrade' || buttonLabel === 'Access Course' || buttonLabel === 'Enroll and pay'"
            >
              <v-col cols="1" class="d-none d-md-block" md="1" />
              <v-col cols="12" md="11" class="about-credit pl-10 ml-0">
                <p style="font-size: 18px; font-weight: bold; margin-bottom: 0px; color: #2a2a2a">
                  Complete the enrollment process
                </p>
                <v-row row wrap>
                  <v-col cols="12" md="8" lg="10" style="padding-bottom: 24px">
                    <ol class="eligible-list">
                      <li>Pay the course enrollment fee.</li>
                      <li>Verify your identity (This process only needs to be completed one time).</li>
                      <li>
                        Once completed, you will be able to access your course starting on the course start date
                        indicated on your dashboard.
                      </li>
                    </ol>
                  </v-col>
                </v-row>
              </v-col></v-row
            >

            <v-row v-else-if="['Add to Transcript', 'Retry for Credit'].indexOf(buttonLabel) > -1">
              <v-col cols="12" class="addToTransClass" :class="{ 'ml-8': $vuetify.display.smAndUp }">
                <p style="font-size: 16px; font-weight: normal; margin-bottom: 12px">
                  Before you get your credit, check our
                  <a
                    class="gpa-calc"
                    href="https://ea.asu.edu/how-it-works/gpa-calculator/"
                    target="_blank"
                    @click="asuoDataLayerClick('courseCheckout', '0')"
                    >GPA Calculator</a
                  >
                  to determine how converting this course will impact your overall GPA.
                </p>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  style="padding: 8px 0px 8px 12px; border-radius: 18px; border: 1px solid rgb(254, 198, 39)"
                >
                  <v-row class="justify-space-between">
                    <v-col cols="12" sm="2" md="2" style="max-width: 50px">
                      <v-row justify-space-between column fill-height>
                        <v-col cols="12" sm="6" md="6" style="padding: 15px 0px 0px 10px">
                          <v-icon style="color: rgb(254, 198, 39)">mdi-alert</v-icon>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="10" xl="10" style="padding: 15px 0px">
                      <p style="margin-bottom: 10px">
                        <strong><b>Be advised that you can only transcript a course ONCE</b></strong>
                      </p>
                      <p style="font-size: 16px; font-weight: normal; margin-bottom: 0">
                        Once you transcript this course, you will no longer have the option to retake it for a different
                        grade.
                      </p>
                    </v-col>
                    <v-col cols="3" md="1" class="align-self-center" />
                  </v-row>
                </v-col>
                <v-row row wrap>
                  <v-col cols="12" sm="12" md="12" lg="12" style="padding-bottom: 24px">
                    <p style="font-weight: 600; margin-bottom: 10px; margin-top: 20px">To get credit:</p>
                    <ol style="font-size: 16px; font-weight: 400; margin-bottom: 10px; padding-left: 19px">
                      <li>
                        <div class="credit-list">Click the checkout button.</div>
                      </li>
                      <li>
                        <div class="credit-list">Enter your payment information, if applicable.</div>
                      </li>
                      <li>
                        <div class="credit-list">
                          Remain on the credit conversion page until you see the Credits Converted Successfully
                          confirmation.
                        </div>
                      </li>
                    </ol>
                  </v-col>
                </v-row>
                <p style="font-size: 16px; font-weight: normal; margin-bottom: 12px">
                  After Arizona State University approves your credit you can request an official transcript from ASU.
                </p>
              </v-col></v-row
            >

            <v-col cols="3" md="1" class="align-self-center" />
          </div>
        </v-col>
        <v-col cols="12" md="4" lg="4" xl="3">
          <v-col cols="12" sm="12" md="12" xl="12" class="pa-0">
            <v-row row>
              <v-col cols="12" sm="12" md="12">
                <div class="sticky-section">
                  <checkout-selected-course
                    ref="checkoutSelectedCourse"
                    v-scroll="onScroll"
                    @next="next($event)"
                    @payment-processing="handlePaymentProcessing"
                    @payment-complete="handlePaymentComplete"
                  />
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { defineComponent } from 'vue';
import { useCheckoutStore } from '@/stores/checkout';

/* eslint-disable no-console */
import { DataLayerMixin } from '../mixins/dataLayerMixin';
import { AjaxLoader } from '../mixins/ajaxLoader';
import { SessionInitializer } from '../mixins/sessionInitializer';
import { Helper } from '../mixins/helpers.js';
import { Logger } from '../mixins/logger';

export default defineComponent({
  name: 'courseCheckout',

  components: {},

  data() {
    return {
      reachedBottom: false,
      checkoutStore: null
    };
  },

  created() {
    // Get checkout store instance
    this.checkoutStore = useCheckoutStore();

    // Redirect to dashboard if no checkout data in store
    if (!this.checkoutStore.hasValidCheckoutData) {
      this.$router.push({ name: 'dashboard' });
      return;
    }

    // Redirect to dashboard if required course details are missing
    if (!(this.coursePrefix && this.title)) {
      this.$router.push({ name: 'dashboard' });
      return;
    }

    this.captureEcomDataLayer('view_cart');
  },

  watch: {},

  computed: {
    pageTitle() {
      return this.checkoutStore?.pageTitle || '';
    },
    // Create computed properties for all checkout data fields from store
    title() {
      return this.checkoutStore?.title || '';
    },
    coursePrefix() {
      return this.checkoutStore?.coursePrefix || '';
    },
    coursePrefixDisplayLabel() {
      return this.checkoutStore?.coursePrefixDisplayLabel || '';
    },
    courseStartDate() {
      return this.checkoutStore?.courseStartDate || '';
    },
    courseType() {
      return this.checkoutStore?.courseType || '';
    },
    courseOfferingName() {
      return this.checkoutStore?.courseOfferingName || '';
    },
    currentGrade() {
      return this.checkoutStore?.currentGrade || '';
    },
    grade() {
      return this.checkoutStore?.grade || 0;
    },
    courseInfo() {
      const info = this.checkoutStore?.courseInfo || {};
      return info;
    },
    buttonLabel() {
      return this.checkoutStore?.buttonLabel || '';
    },
    benefitType() {
      return this.checkoutStore?.benefitType || '';
    },
    finalGrade() {
      return this.checkoutStore?.finalGrade || '';
    },
    buttonAction() {
      return this.checkoutStore?.buttonAction || '';
    },
    courseCompletedDate() {
      return this.checkoutStore?.courseCompletedDate || '';
    },
    courseOfferingId() {
      return this.checkoutStore?.courseOfferingId || '';
    },
    enrollmentId() {
      return this.checkoutStore?.enrollmentId || '';
    },
    creditConversionPrice() {
      return this.checkoutStore?.creditConversionPrice || 0;
    },
    creditEligibilityPrice() {
      return this.checkoutStore?.creditEligibilityPrice || 0;
    },
    canvasEnrollmentId() {
      return this.checkoutStore?.canvasEnrollmentId || null;
    },
    canvasUserId() {
      return this.checkoutStore?.canvasUserId || null;
    },
    canvasCourseId() {
      return this.checkoutStore?.canvasCourseId || null;
    },
    credits() {
      return this.checkoutStore?.credits || 0;
    },
    enrollmentDate() {
      return this.checkoutStore?.enrollmentDate || '';
    },
    from() {
      return this.checkoutStore?.from || '';
    },
    lms() {
      return this.checkoutStore?.lms || '';
    },
    benefitsEligible() {
      return this.checkoutStore?.benefitsEligible || false;
    },
    enrollmentType() {
      return this.checkoutStore?.enrollmentType || '';
    }
  },

  mixins: [AjaxLoader, DataLayerMixin, SessionInitializer, Helper, Logger],

  // Props removed - using Pinia checkout store instead

  methods: {
    captureEcomDataLayer(event) {
      // Clear previous ecommerce object
      if (window.dataLayer) {
        window.dataLayer.push({ ecommerce: null });
      }

      // Format course name to lowercase with underscores
      const courseName = `${this.coursePrefix} ${this.title}`.toLowerCase().replace(/\s+/g, '_');

      //Ecom data layer
      const ecom = {
        event: event,
        ecommerce: {
          currency: 'USD',
          value: 25.0,
          ...(event === 'purchase' && {
            transaction_id: this.transactionID
          }),
          items: [
            {
              item_id: courseName,
              item_name: courseName,
              price: 25.0,
              quantity: 1
            }
          ]
        }
      };

      this.asuoDataLayerClick('ecommerceTags', '0', ecom);
    },

    handlePaymentProcessing() {
      // Show page-wide spinner when PayPal payment is processing
    },

    handlePaymentComplete() {
      // Clear page-wide spinner when payment processing completes
    },

    next(event) {
      this.logInfo('courseCheckout', event);

      // Payment processing spinner is now handled by payment events
      // Start loading for transaction completion

      // Handle payment with payment method and transactions
      // Receipt dates reflect the EMVD (Enrollment Mode Verified Date) — when the
      // learner completed enrollment — not the course offering's start date.
      const enrollmentStartDate = new Date();
      const enrollmentEndDate = new Date(enrollmentStartDate);
      enrollmentEndDate.setFullYear(enrollmentStartDate.getFullYear() + 1);

      let transactionData = {
        courseCode: this.coursePrefix,
        courseTitle: this.title,
        coursePrefixDisplayLabel: this.coursePrefixDisplayLabel,
        startDate: enrollmentStartDate.toLocaleDateString(),
        endDate: enrollmentEndDate.toLocaleDateString(),
        credits: this.credits || '3',
        buttonAction: this.buttonAction,
        finalGrade: this.finalGrade,
        enrollmentId: this.enrollmentId,
        from: this.from
      };

      if ((event.payer || {}).payment_method && event.transactions[0]) {
        transactionData.transactionId = event.id;
        transactionData.orderNumber = event.transactions[0].invoice_number;
        transactionData.totalAmount = event.transactions[0].amount.total;
        transactionData.orderDate = new Date().toLocaleDateString();
      } else if (event.paymentMode === 'free') {
        // Handle voucher-based free transactions
        transactionData.transactionId = event.id || 'free' + Math.random().toString(36).substring(2, 15);
        transactionData.orderNumber =
          (event.transactions && event.transactions[0]?.invoice_number) || `free-` + this.generateInvoiceNumber();
        transactionData.totalAmount = event.transactions[0].amount.total;
        transactionData.orderDate = new Date().toLocaleDateString();
      } else {
        // Handle benefits eligible transactions
        transactionData.totalAmount = 0;
        transactionData.transactionId = 'BE-' + Date.now();
        transactionData.orderNumber = 'BE-' + this.generateInvoiceNumber();
        transactionData.orderDate = new Date().toLocaleDateString();
      }

      // Store transaction data in session storage
      sessionStorage.setItem('checkoutTransactionData', JSON.stringify(transactionData));

      // Navigate to completion page (data stored in sessionStorage)
      this.$router.push({
        name: 'courseCheckoutCompletion'
      });
    },

    onScroll() {
      if (window.innerHeight + window.scrollY >= document.documentElement.offsetHeight - 250) {
        this.reachedBottom = true;
      } else {
        this.reachedBottom = false;
      }
    },

    // Add this method to generate invoice number consistently
    generateInvoiceNumber() {
      let today = new Date().toISOString().slice(0, 10).replace(/-/g, '').slice(2);
      let prefix = import.meta.env.VITE_ENV_HOOK === 'prod' ? 'PRODOSPP' : 'OSPP';
      let random2Char = '';
      let random3Char = '';
      let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      let charactersLength = characters.length;

      for (let i = 0; i < 2; i++) {
        random2Char += characters.charAt(Math.floor(Math.random() * charactersLength));
      }

      for (let i = 0; i < 3; i++) {
        random3Char += characters.charAt(Math.floor(Math.random() * charactersLength));
      }

      return `${prefix}-${today}${Math.floor(Math.random() * 10)}${random2Char}${Math.floor(Math.random() * 100)}${random3Char}`;
    }
  },

  mounted() {
    // Send checkout page view event
    const checkoutPageEvent = {
      event: 'page_view',
      page_type: 'checkout',
      page_path: this.$route.path,
      course_info: {
        course_prefix: this.coursePrefix,
        course_title: this.title,
        course_full_name: `${this.coursePrefix} ${this.title}`
      }
    };

    if (window.dataLayer) {
      window.dataLayer.push(checkoutPageEvent);
    }

    const bannerElement = document.getElementById('banner-12');
    if (bannerElement) {
      bannerElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center'
      });
    }
  }
});
</script>
